import Link from '@tiptap/extension-link';

/**
 * The Link mark with `inclusive: false` (#96).
 *
 * Stock TipTap makes the link mark inclusive whenever `autolink` is on, so the
 * cursor at the end of a link carries the mark and everything typed there -
 * the space after a pasted URL and the sentence after it - joins the link.
 * Autolink does not need inclusivity: it re-scans the word before each
 * whitespace and links it, so a URL typed by hand is still linked. Typing
 * INSIDE a link still extends it, because both neighbours carry the mark.
 */
export const DossierLink = Link.extend({
  inclusive() {
    return false;
  },
});
